import { render, staticRenderFns } from "./DnsZoneCache.vue?vue&type=template&id=35e518f4&"
import script from "./DnsZoneCache.vue?vue&type=script&lang=js&"
export * from "./DnsZoneCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports